export default __webpack_public_path__ + "static/media/choose-signature-layout.2a58200d.svg";